import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../../shared/common.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['../full.component.scss']
})
export class AppHeaderComponent implements OnInit{
  userData;
  ntervalId:any;
  audio:any;
  interval:any;
  constructor(private commonService: CommonService) { }

  ngOnInit() {
    this.userData = this.commonService.getUser();
    // this.play();

    // this.interval = setInterval( () => {
    //   this.play();
    //   }, 15000);
  }

   play() {
    var audio = new Audio('https://s3.us-east-1.amazonaws.com/throneapp/throne/1629872945548_notification_sound.mp3');
    audio.play();
  }

  logoutUser() { 
      this.commonService.logOut();
  }




}

